import {
  App,
  Button, Checkbox, DatePicker, Form, FormInstance,
} from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import { useWatch } from 'antd/es/form/Form';
import styles from './index.module.scss';
import SelectFrequency from '../../../../Common/SelectFrequency';
import { PlatformEnum, UserDetail } from '../../../../../store/users';
import ModalPayments from './Modal';
import { updateUnsavedChanges } from '../../../../../store/unsavedChanges';
import { useAppDispatch } from '../../../../../hooks/redux';

interface IUserSubscriptionProps {
  data?: UserDetail;
  form?: FormInstance<UserDetail>;
}

export default function UserSubscription({ data, form }: IUserSubscriptionProps) {
  const { message } = App.useApp();
  const dispatch = useAppDispatch();

  const handleSetupHorses = () => {
    if (!form?.getFieldValue('mustSetupHorses')) {
      form?.setFieldValue('mustSetupHorses', true);
      message.success('Selection is active now');

      dispatch(updateUnsavedChanges(true));
    }
  };

  const mustSetupHorses = useWatch('mustSetupHorses', form);

  return (
    <>
      <Form.Item name="subscription" label="Current plan">
        <SelectFrequency />
      </Form.Item>
      <Form.Item name="subscriptionTill" label="Expiration date">
        <DatePicker className={styles.wFull} showTime />
      </Form.Item>
      <Form.Item hidden={!data?.payments?.length} name="platform" label="Platform">
        {data?.payments?.[0]?.platform ? PlatformEnum[data?.payments?.[0]?.platform] : '-'}
      </Form.Item>
      <Form.Item label="buttons" className={styles.hideLabel}>
        <div className={styles.btnWrap}>
          <div>
            <Button onClick={() => ModalPayments({ data })}>
              View purchase history
            </Button>
          </div>
          <div className={styles.btnFlex}>
            <CheckOutlined className={mustSetupHorses ? styles.iconGreen : ''} />
            <Button
              disabled={mustSetupHorses}
              onClick={handleSetupHorses}
            >
              Allow horse subscription selection
            </Button>
          </div>

        </div>
      </Form.Item>
      <Form.Item hidden label="Must Setup Horses" name="mustSetupHorses" valuePropName="checked">
        <Checkbox />
      </Form.Item>
    </>
  );
}

UserSubscription.defaultProps = {
  data: undefined,
  form: undefined,
};
